<div id="chat-container" [ngStyle]="{'width': width }" [ngClass]="chatmode.toLowerCase()" >
    <div id="chatbox" [ngClass]="{'alwaysOpen': user.chat.alwaysOpen}" #chatbox>
        <div *ngFor="let message of filteredMessages; trackBy: trackByDate" class="message" [ngStyle]="{'zoom': user.chat.zoom / 100 }" [ngClass]="message.channel.toLowerCase()">
            <span *ngIf="message.rolls==undefined">
                <span style="margin-right: 3px;" (click)="setWhisperTarget(message)">
                    <b [ngStyle]="{'color': message.color}">
                        {{message.name}}
                    </b>
                </span>
                <span *ngIf="message.imageUrl==undefined">{{message.text}}</span>
                <div class="image" *ngIf="message.imageUrl!=undefined">
                    <img [src]="message.imageUrl" crossorigin="anonymous" (load)="scrollChatbox()" />
                </div>
            </span>
            <div class="roll-header" *ngIf="message.rolls" [ngStyle]="{'border-color': message.color}" >
                <span style="display: flex;">
                    <span style="margin-right: 5px;" (click)="setWhisperTarget(message)">
                        <b class="message-name" [ngStyle]="{'color': message.color }">
                            {{message.name}}
                        </b>
                    </span>
                    <span class="roll-text">rolled {{message.text}}</span>
                    <span class="roll-date">{{message.date}}</span>
                </span>
                <ng-container *ngIf="message.rolls">
                    <span *ngFor="let roll of message.rolls" class="roll-container">
                        <ng-container *ngIf="roll.type=='die'">
                            <app-dice [rolls]="roll.rolls"></app-dice>
                        </ng-container>
                        <ng-container *ngIf="roll.type=='expressionroll'">
                            <app-dicegroup [group]="roll.dice" [ops]="roll.ops"></app-dicegroup>
                        </ng-container>
                        <ng-container *ngIf="roll.rolls == null || roll.rolls.length == 0 || roll.rolls[0].success==false">
                            <span class="roll-final" [ngStyle]="{'color': message.color}">
                                <span>= {{roll.value}}</span>
                            </span>
                        </ng-container>
                        <ng-container *ngIf="roll.rolls && roll.rolls.length > 0 && roll.rolls[0].success==true">
                            <span class="roll-value" [ngStyle]="{'color': 'limegreen' }" *ngIf="roll.value>0">= {{roll.value}} successes</span>
                            <span class="roll-value" [ngStyle]="{'color': 'orangered' }" *ngIf="roll.value==0">= no successes</span>
                        </ng-container>
                    </span>
                </ng-container>
            </div>
        </div>
    </div>
    <div id="chat-settings-container" [ngClass]="{'show': showSettings}">
        <div id="chat-settings">
            <mat-slider [max]="800" [min]="300" [step]="100" [disabled]="!showSettings" class="width-slider">
                <input matSliderThumb [(ngModel)]="user.chat.width" #widthslider (input)="changeSetting($event)">
            </mat-slider>
            <div>
                <label style="margin-right: 10px; font-weight: 500px;">Zoom</label>
                <label>{{zoomslider.value}}%</label>
            </div>
            <mat-slider [max]="200" [min]="40" [step]="20" [disabled]="!showSettings">
                <input matSliderThumb [(ngModel)]="user.chat.zoom" #zoomslider (input)="changeSetting($event)">
            </mat-slider>
            <mat-slide-toggle [(ngModel)]="user.chat.autoscroll" class="menu-item" (click)="changeSetting($event)" [labelPosition]="'before'" [disabled]="!showSettings">
                Autoscroll
            </mat-slide-toggle>
            <mat-slide-toggle [(ngModel)]="user.chat.alwaysOpen" class="menu-item" (click)="changeSetting($event)" [labelPosition]="'before'" [disabled]="!showSettings">
                Always open
            </mat-slide-toggle>
            <mat-slide-toggle [(ngModel)]="user.chat.keepOpenAfterSend" [disabled]="user.chat.alwaysOpen" class="menu-item" (click)="changeSetting($event)" [labelPosition]="'before'" [disabled]="!showSettings">
                Stay open after message
            </mat-slide-toggle>
        </div>
    </div>
    <div id="chat-controls">
        <span id="chat-destination" (click)="mode()">[All]</span>
        <div id="chat-input">
            <input [(ngModel)]="message" #chatinput placeholder="press enter to chat..." maxlength="300" (keydown)="keydown($event)" />
        </div>
        <button mat-icon-button id="chat-open-settings" (click)="openSettings(!showSettings)">
            <mat-icon>settings</mat-icon>
        </button>
    </div>
</div>
